import mqtt from 'utils/mqtt'

export default {
  install(Vue) {
    Vue.prototype.$mqtt = mqtt
  }
}
